import React, { useRef } from 'react';
var VeltIf = function (props) {
    var condition = props.condition, children = props.children, className = props.className, id = props.id;
    var ref = useRef();
    return (React.createElement("velt-if", { ref: ref, condition: condition, class: className, id: id }, children));
};
export default VeltIf;
